<template>
  <div class="tyreList">
    <router-link to="/search?from=tyre&event=搜索" tag="div" class="search">
      <img src="../../../assets/images/tyreIcon.png" alt="" />
    </router-link>
    <section class="selectBox fvlr">
      <Selector :result="cityInfo.text" width="48%" icon="location-o" placeHolder="定位失败" @click="showCity += 1" />
      <Selector :result="model" width="48%" placeHolder="请选择车系车型" @click="showModel += 1" />
      <Selector :result="tyreSize" width="48%" placeHolder="请选择规格(必选)" @click="showTyreSize += 1" />
      <Selector :result="tyreBrands" width="48%" placeHolder="请选择轮胎品牌" @click="showTyreBrands += 1" />
      <van-button class="btn" :disabled="searching || !cityInfo.id" @click="searchFn" type="primary">{{ searching ? '搜索中...' : '搜索轮胎' }}</van-button>
      <div class="fvlr guide">
        <div class="empty"></div>
        <div class="fc" @click="showHowSelectTyre++"><van-icon name="info" color="#aaaaaa" />&nbsp;&nbsp;如何选择轮胎</div>
        <div class="fvcd del" @click="deleteData"><img src="../../../assets/images/del.svg" alt="" />&nbsp;清空</div>
      </div>
    </section>

    <van-loading v-if="searching" size="24px" vertical class="loading">数据加载中...</van-loading>
    <Divider
      v-if="!searching && tyreList.length"
      class="divider"
      imgWidth="25%"
      :text="tyrePackageList.length ? `为您匹配了${tyrePackageList.length}个轮胎套餐和${tyreList.length}种轮胎` : `为您匹配了${tyreList.length}种轮胎`"
    />
    <img v-if="!tyreList.length && !tyrePackageList.length && !searching" class="nodata" src="../../../assets/images/noData.svg" />
    <section>
      <div>
        <template v-for="item in tyrePackageList" :key="item.id">
          <TirePackage :data="item" :gsCode="gsCode" :customerCarId="carInfo?.id" @link="toTirePackage(item)" />
        </template>
        <template v-for="(item, index) in tyreList" :key="item.id">
          <TyreCard :top="index === 0" :datas="item" @link="toDetail(item)" />
        </template>
      </div>
    </section>
    <SelectCity :fromTyre="true" :indexArr="cityInfo.indexArr" :provinceCity="cityInfo.provinceCity" :showNum="showCity" @getCity="getCity" />
    <SelectCar :datas="modelList" :showPopUp="showModel" :currentCar="currentCar" @selectCarResult="selectCarResult" />
    <SingleRow title="轮胎规格" :datas="tyreSizeList" :allDatas="allTyreSizeList" :showPopUp="showTyreSize" @emitClick="confirmTyreSize" />
    <SingleRow title="轮胎品牌" :datas="tyreBrandsList" :showPopUp="showTyreBrands" @emitClick="confirmTyreBrands" />
    <PopUp :showPopUp="showHowSelectTyre" :datas="popUpcontent" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import Selector from '@/components/common/Selector.vue'
import SelectCity from '@/components/common/SelectCity.vue'
import SelectCar from '@/components/common/SelectCar'
import Divider from '@/components/common/Divider'
import SingleRow from '@/components/tyre/SingleRow'
import TyreCard from '@/components/tyre/TyreCard'
import TirePackage from '@/components/shop/YearTirePackage'
import PopUp from '@/components/common/PopUp'
import { getVehiclePickerData, getTyresList } from '@/api/tyre'
import { getMyDefault } from '@/api/car'
import { useRoute, useRouter } from 'vue-router'
import { setSession, getSession } from '@/util'
import { getDefaultCityId } from '@/util/city'
import { Toast } from 'vant'
import { useStore } from 'vuex'
import _ from 'lodash'
import { getModelList, getAllTyreSizeList, getTyreBrands, getBrandsforSpec, tryeToSpecFn, getCurrentModelList } from '@/util/tyreList'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
export default {
  name: 'tyreList',
  components: {
    Selector,
    SelectCity,
    SelectCar,
    SingleRow,
    Divider,
    TyreCard,
    TirePackage,
    PopUp
  },
  setup() {
    let router = useRouter()
    let route = useRoute()
    let store = useStore()
    let { dealerInfo } = store.state
    const { carInfo } = useCurrentCarInfo()
    const state = reactive({
      gsCode: dealerInfo?.gsCode,
      carInfo,
      showCity: 0,
      showModel: 0,
      showTyreSize: 0,
      showTyreBrands: 0,
      showHowSelectTyre: 0,
      searching: false,
      cityInfo: getSession('tyreCity') || {
        text: (store.state.locationInfo && store.state.locationInfo.city) || ''
      },
      model: getSession('tyreModel'),
      tyreSize: getSession('tyreSize'),
      brand: '',
      tyreBrands: getSession('tyreBrands')?.text || '',
      tyreBrandsVal: getSession('tyreBrands')?.value || '',
      baumuster: '',
      modelList: [],
      allModelList: [],
      vehiclePickerData: '',
      tyreList: [],
      tyrePackageList: [],
      tyreSizeList: getSession('tyreSizeList') || [],
      allTyreSizeList: [],
      tyreBrandsList: [],
      popUpcontent: {
        title: ' ',
        content: `<img style="width:100%;" src="${store.state.staticDomain}/mp/staticimg/tyreD3.png"/>`
      },
      currentCar: [],
      currentCarSelect: {},
      couponId: route.query.couponId,
      allTyreBrandsList: [],
      cityId: '',
      tryeToVehiles: []
    })
    // 选择轮胎规格，反选车型列表
    const confirmTyreSize = async val => {
      state.tyreSize = val
      let classes = state.tryeToVehiles[val].map(item => item.substring(1))
      state.modelList = await getCurrentModelList(classes, state.allModelList)
      getDefaultCar(state.modelList, state.currentCarSelect)
    }
    const confirmTyreBrands = val => {
      if (!val.value) {
        state.tyreBrands = ''
        state.tyreBrandsVal = ''
        setSession('tyreBrands', '')
        return
      }
      state.tyreBrands = val.text
      state.tyreBrandsVal = val.value
      setSession('tyreBrands', val)
    }
    const getCity = val => {
      state.cityInfo = val
      setSession('tyreCity', val)
    }
    // 清空按钮，包括所有缓存
    const deleteData = () => {
      state.model = ''
      state.tyreSize = ''
      state.tyreBrands = ''
      state.tyreBrandsVal = ''
      state.tyreSizeList = state.allTyreSizeList
      state.tyreBrandsList = state.allTyreBrandsList
      state.tyrePackageList = state.modelList = state.allModelList
      state.tyreList = []
      state.tyrePackageList = []
      state.currentCarSelect = {}
      setSession('tyreModel', '')
      setSession('tyreBrands', '')
      setSession('tyreSize', '')
      setSession('tyreSizeList', '')
      setSession('tyresList', '')
      setSession('tyrePackageList', '')
      setSession('modelList', state.allModelList)
    }
    // 选择车型
    const selectCarResult = val => {
      if (!val.value) {
        state.model = ''
        state.tyreSize = ''
        state.tyreSizeList = state.allTyreSizeList
        setSession('tyreSizeList', state.allTyreSizeList)
        setSession('tyreModel', '')
        return
      }
      state.currentCarSelect = {
        series: val.series.split('级')[0],
        model: val.text
      }
      setSession('tyreModel', val.text)
      state.model = val.text
      // 联动轮胎规格
      state.tyreSizeList = state.vehiclePickerData.tyres[`s${val.value}`].map(item => {
        return item.value
      })
      // 不要轮胎规格默认值了，先注释
      // state.tyreSize = state.tyreSizeList[0];
      // state.tyreSize = ''
      setSession('tyreSizeList', state.tyreSizeList)
    }
    const toTirePackage = item => {
      console.log(item)
      store.dispatch('setBrandInfo', { brand: state.tyreBrands, spec: state.tyreSize })
      //  if (item.productType === 'TirePackage') {
      // store.dispatch('setLoyalty', item)
      router.push({ path: '/planDetail', query: { loyaltyId: item.loyaltyId, from: 'tireList', event: '查看轮胎包计划详情' } })
      // return false
      // }
    }
    const toDetail = item => {
      store.commit('SETCURRENTTYRE', item)
      router.push({
        path: '/tyreDetail',
        query: {
          tyreId: item.id,
          model: state.model,
          cityId: state.cityInfo.id,
          gsCode: route.query.gsCode,
          tyrePackageLoyaltyList: JSON.stringify(item.tyrePackageLoyaltyList),
          event: '轮胎详情'
        }
      })
    }
    // 搜索接口
    const searchInterface = async params => {
      let { list, tyrePackageList } = await getTyresList(params).catch(() => {
        state.searching = false
      })
      // 对轮胎状态进行排序，首个位置不变、有货排前面、无货排后面
      let first = list.splice(0, 1)
      let hasCommodity = list.filter(item => item.has_commodity)
      let noCommodity = list.filter(item => !item.has_commodity)
      let result = [...first, ...hasCommodity, ...noCommodity]
      setSession('tyresList', result)
      setSession('tyrePackageList', tyrePackageList)
      state.tyreList = result
      state.tyrePackageList = tyrePackageList
      state.searching = false
    }
    // 搜索按钮
    const searchFn = async () => {
      if (state.searching) return
      if (!state.cityInfo) {
        Toast({
          message: `请选择所在城市`,
          position: 'bottom'
        })
        return
      }
      if (!state.tyreSize) {
        Toast({
          message: `请选择轮胎规格`,
          position: 'bottom'
        })
        return
      }
      state.searching = true
      state.tyreList = []
      let params = {
        tyreSpec: state.tyreSize,
        cityId: state.cityInfo.id,
        model: state.model,
        brandCode: state.tyreBrandsVal,
        customerCarId: state.carInfo?.id || ''
      }
      searchInterface(params)
    }

    const setCity = n => {
      state.cityInfo.text = n.city
      state.cityInfo.provinceCity = [n.province, n.city]
    }
    const getTyreListFromCoupon = async () => {
      state.searching = true
      state.cityInfo.id = await getDefaultCityId()
      let params = {
        cityId: state.cityInfo.id,
        couponId: state.couponId
      }
      searchInterface(params)
    }
    const showDefaultCar = async () => {
      let defaultCar = await getMyDefault({
        user: '123'
      })
      getDefaultCar(state.modelList, defaultCar)
    }
    const getDefaultCar = async (modelList, defaultCar) => {
      let currentCar = {
        seriesIndex: 0,
        modelList: [],
        modelIndex: 0
      }
      // 默认车辆信息进行反选找到对应的位置（弹框的index）
      let { seriesIndex, seriesList } = await getDefaultModelList(modelList, defaultCar)
      if (!seriesList) {
        seriesIndex = 0
        seriesList = modelList
        state.model = ''
        defaultCar = ''
        setSession('tyreModel', '')
      }
      //页面回退
      state.modelList = modelList
      setSession('modelList', modelList)

      let list = seriesList.children
      currentCar.modelList = list
      currentCar.seriesIndex = seriesIndex
      let defaultCarModel = defaultCar?.model?.replace(/\s*/g, '').replace(/\(.*?\)/g, '')
      currentCar.modelIndex = defaultCarModel ? currentCar.modelList.findIndex(item => item.text.replace(/\s*/g, '') === defaultCarModel) : 0
      if (currentCar.modelIndex < 0) {
        // 没有匹配的车型，不显示
        // Toast({ message: "该车型已停用，请切换车型", position: "bottom" });
        return
      }
      state.model = defaultCar.model && defaultCar.model.replace(/\(.*?\)/g, '')
      setSession('tyreModel', defaultCar.model)
      state.currentCar = currentCar
      state.currentCarSelect = defaultCar

      // 联动轮胎规格
      let modelItem = list[currentCar.modelIndex]
      if (modelItem && modelItem.value && state.vehiclePickerData.tyres[`s${modelItem.value}`]) {
        state.tyreSizeList = state.vehiclePickerData.tyres[`s${modelItem.value}`].map(item => item.value)
        setSession('tyreSizeList', state.tyreSizeList)
      }
    }
    const getDefaultModelList = (modelList, defaultCar) => {
      return new Promise(resolve => {
        let seriesIndex = ''
        let seriesList = modelList.find((item, index) => {
          if (item.text.split('级')[0] === defaultCar.series) {
            seriesIndex = index
            return true
          }
        })
        resolve({ seriesIndex, seriesList })
      })
    }
    const getInfoFromQR = () => {
      if (!_.isEmpty(route.query)) {
        // saId=123996&gsCode=GS0035377&quantity=4&chargeOffQuantity=1&amount=20.0&coupon=ND6TBQ,SCFQXE,N3JFQH,4TCZ3E
        setSession('sixCoupons', route.query)
        // let defaultDealer = {
        //   gs_code: route.query.gsCode
        // }
        // store.commit('SETDEARINFO', defaultDealer)
      }
    }
    watch(
      () => store.state.locationInfo,
      n => {
        setCity(n)
        if (state.couponId) {
          getTyreListFromCoupon()
        }
      }
    )
    watch(
      () => state.cityInfo.text,
      async () => {
        if (!state.cityInfo.id) {
          state.cityInfo.id = await getDefaultCityId()
        }
      }
    )
    watch(
      () => state.tyreSize,
      n => {
        state.tyreBrandsList = getBrandsforSpec(state.vehiclePickerData, n)
        state.tyreBrands = state.tyreBrandsVal = ''
        setSession('tyreSize', n)
      }
    )
    onMounted(async () => {
      store.dispatch('setBrandInfo', null)
      // 从B端二维码管理扫码过来，对相应的query进行缓存，轮胎下单时有用到
      getInfoFromQR()

      let isFirst = false
      // 获取搜索列表各种信息
      let vehiclePickerData = getSession('vehiclePickerData')
      if (!vehiclePickerData) {
        isFirst = true
        vehiclePickerData = await getVehiclePickerData()
        setSession('vehiclePickerData', vehiclePickerData)
      }
      state.vehiclePickerData = vehiclePickerData

      // 根据定位确定城市id
      let locationInfo = store.state.locationInfo
      if (locationInfo.city && !getSession('tyreCity')) {
        setCity(locationInfo)
        state.cityInfo.id = await getDefaultCityId()
      }
      // 获取车型车系列表
      let modelList = getSession('modelList')
      if (modelList) {
        // 回退页面
        state.modelList = modelList
        state.allModelList = getModelList(vehiclePickerData.vehicles)
      } else {
        state.modelList = state.allModelList = getModelList(vehiclePickerData.vehicles)
        setSession('modelList', state.modelList)
      }
      // 获取轮胎规格
      state.allTyreSizeList = await getAllTyreSizeList(vehiclePickerData.tyres)
      // 获取轮胎品牌
      state.tyreBrandsList = state.allTyreBrandsList = getTyreBrands(vehiclePickerData.tyre_brands)
      // 获取轮胎规格和车辆的对应关系
      state.tryeToVehiles = tryeToSpecFn(state.allTyreSizeList, vehiclePickerData.tyres)
      if (state.couponId) {
        // 从优惠券过来,参数只传城市
        if (locationInfo.city) {
          state.model = state.tyreSize = ''
          getTyreListFromCoupon()
        }
        return
      } else {
        let tyresList = getSession('tyresList')
        let tyrePackageList = getSession('tyrePackageList')
        state.tyreList = tyresList || []
        state.tyrePackageList = tyrePackageList || []
      }
      if (!isFirst) return
      // 获取默认车辆，只有一次
      showDefaultCar()
    })

    return {
      ...toRefs(state),
      getCity,
      toTirePackage,
      selectCarResult,
      searchFn,
      confirmTyreSize,
      confirmTyreBrands,
      toDetail,
      deleteData
    }
  }
}
</script>

<style lang="scss" scoped>
.tyreList {
  box-sizing: border-box;
  padding-bottom: 60px;
  width: 99.9%; //iPhone要左右滑动
}
.selectBox {
  margin-top: 18px;
  padding: 0 20px;
  flex-wrap: wrap;
  > div {
    margin-bottom: 8px;
  }
}
.btn {
  width: 100%;
}
.nodata {
  width: 100px;
  margin-top: 35px;
}
.guide {
  width: 100%;
  color: #aaaaaa;
  margin: 10px 0 0;
  font-size: 13px;
  .empty {
    width: 45px;
    height: 0;
  }
  .del {
    color: #3088c5;
    img {
      width: 14px;
      height: 14px;
      margin-bottom: 1px;
    }
  }
}
.divider {
  color: #999999;
}
:deep(.van-action-sheet__content) {
  z-index: -1;
}
.loading {
  margin-top: 100px;
}
.search {
  position: fixed;
  left: 0;
  top: 182px;
  background: rgba(0, 0, 0, 0.5);
  padding: 9px 16px 7px 24px;
  border-radius: 0 40px 40px 0;
  z-index: 100;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
